export const theme = {
  colors: {
    primary: '#2962FF',
    primaryHover: '#0039CB',
    secondary: '#455A64',
    secondaryHover: '#263238',
    success: '#2E7D32',
    warning: '#ED6C02',
    danger: '#D32F2F',
    text: '#111827',
    muted: '#6B7280',
    border: '#E5E7EB',
    surface: '#FFFFFF',
    overlay: 'rgba(17, 24, 39, 0.6)'
  },
  space: {
    xs: '4px',
    sm: '8px',
    md: '12px',
    lg: '16px',
    xl: '24px'
  },
  radii: {
    sm: '6px',
    md: '10px',
    lg: '14px',
    pill: '9999px'
  },
  shadow: {
    sm: '0 1px 2px rgba(0,0,0,0.06)',
    md: '0 4px 8px rgba(0,0,0,0.08)',
    lg: '0 8px 16px rgba(0,0,0,0.12)'
  },
  fontSizes: {
    xs: '12px',
    sm: '14px',
    md: '16px',
    lg: '18px',
    xl: '24px',
    xxl: '32px'
  },
  zIndex: {
    modal: 11000,
    overlay: 10900,
    dropdown: 800
  },
  
  breakpoints: {
    xs: 480,
    sm: 640,
    md: 768,
    lg: 1024,
    xl: 1280
  },
  layout: {
    container: {
      direction: 'column',
      gap: '16px',
      alignItems: 'stretch',
      justify: 'flex-start',
      padding: '16px 32px',
      maxWidth: '100%',
      wrap: 'nowrap'
    },
    grid: {
      gap: '16px',
      columns: 12,
      minColWidth: '220px'
    },
    box: {
      padding: '16px',
      radius: '10px',
      shadow: 'sm'
    },
    page: {
      padding: '24px 32px',
      maxWidth: '100%'
    },
    section: {
      paddingY: '24px',
      gap: '16px'
    }
  }
}
